import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import { ApiParams } from '../../types'
import TrailersViewApi from './api'

interface UseTrailersViewProps extends ApiParams {}

const useTrailersView = ({ filters }: UseTrailersViewProps) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.TRAILERS_ADMIN, filters],
    () => TrailersViewApi.getTrailers({ filters }),
    {
      staleTime: Infinity,
    },
  )

  return {
    trailers: data,
    isLoading,
  }
}

export default useTrailersView
